import { render, staticRenderFns } from "./CalendarioObrigacoes.vue?vue&type=template&id=4eabb532&scoped=true&"
import script from "./CalendarioObrigacoes.vue?vue&type=script&lang=js&"
export * from "./CalendarioObrigacoes.vue?vue&type=script&lang=js&"
import style0 from "./CalendarioObrigacoes.vue?vue&type=style&index=0&id=4eabb532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eabb532",
  null
  
)

export default component.exports